import getFormattedAddressFromGoogleAddress from 'components/ReusableComponents/HotelAutocomplete/helpers'
import GooglePlacesAutocomplete from 'react-google-places-autocomplete'
import { geocodeByPlaceId } from 'react-google-places-autocomplete'

const HotelAutocomplete = ({ onChange, defaultValue }) => {
  async function getPlaceDetails(place) {
    if (place) {
      const placeId = place.value.place_id
      const hotelName = place.value.structured_formatting.main_text

      geocodeByPlaceId(placeId)
        .then(results => {
          onChange({ hotelName, ...getFormattedAddressFromGoogleAddress(results[0]) })
        })
        .catch(error => console.error(error))
    }
  }

  const MIN_LENGTH = 5

  function noOptions(value) {
    if (value.inputValue.length < MIN_LENGTH) {
      return null
    }

    return 'No results'
  }

  return (
    <GooglePlacesAutocomplete
      autocompletionRequest={{
        types: ['establishment'],
        country: ['us', 'ca']
      }}
      minLengthAutocomplete={5}
      selectProps={{
        onChange: val => {
          if (!val) {
            onChange(null)
            return
          }
          getPlaceDetails(val)
        },
        placeholder: 'Search with hotel name...',
        noOptionsMessage: noOptions,
        isClearable: true,
        defaultInputValue: defaultValue,
        styles: {
          control: provided => ({
            ...provided,
            background: '#f8f8fc',
            border: '1px solid rgba(0, 0, 60, 0.2)'
          }),
          container: provided => ({
            ...provided,
            boxSizing: 'border-box',
            boxShadow: 'inset 0px 4px 3px rgba(0, 0, 0, 0.02)',
            borderRadius: '3px',
            height: '38px',
            fontSize: '14px'
          }),
          input: provided => ({
            ...provided,
            //padding: '0 12px',
            background: '#f8f8fc'
          })
        }
      }}
    />
  )
}

export default HotelAutocomplete
